export default {"src":"/_next/static/media/0xfb6115445bff7b52feb98650c87f44907e58f802.94d275b4.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};